import React from "react";
import loading_svg from "styles/common/img/common/loading_svg.svg";
import loading_default from "styles/common/img/common/loading_default.svg";
import styled from "styled-components";

function Loading(props) {
    const { loading_color = null, loading_margin = "auto" } = props;
    return (
        <LoadingWrap>
            <div className="background">
                <div className="loadingWrap">
                    <div className="loading" style={{ margin: loading_margin }}>
                        <img src={loading_color === "default" ? loading_default : loading_svg} alt="로딩" />
                    </div>
                </div>
            </div>
            <div className="background_backdrop" />
        </LoadingWrap>
    );
}

const LoadingWrap = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 1050;

    .background {
        position: relative;
        height: 100%;
        width: 100%;
        background-color: transparent;
        opacity: 0.8;
    }

    .loadingWrap {
        position: absolute;
        // transform: translate(-50%, -58%);
        left: 50%;
        top: 50%;
    }

    .background_backdrop {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 1040;
        width: 100vw;
        height: calc(100% - 0px);
        background-color: transparent;
    }
`;

export default Loading;
